import React from "react"
import { motion } from "framer-motion"
import { LoaderCircle } from "lucide-react"

interface PageLoaderProps {
  text?: string
}

const PageLoader: React.FC<PageLoaderProps> = ({ text = "Loading..." }) => {
  return (
    <div className="f-ull flex items-center justify-center">
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.3 }}
        className="flex flex-col items-center justify-center space-y-4"
      >
        <div className="relative">
          <LoaderCircle className="h-12 w-12 text-legacy-blue animate-spin" />
          <motion.div
            className="absolute inset-0 border-4 border-legacy-blue/20 rounded-full"
            animate={{ rotate: 360 }}
            transition={{ duration: 2, repeat: Infinity, ease: "linear" }}
          />
        </div>
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.2 }}
          className="text-sm font-medium text-legacy-dark dark:text-slate-200"
        >
          {text}
        </motion.p>
      </motion.div>
    </div>
  )
}

export default PageLoader
